/**
 * Represents a category template, extending the backend category template.
 * @extends BackendCategoryTemplate
 */
import { CategoryTemplate as BackendCategoryTemplate } from "@longtail-education/superprep-data-model-frontend"

export class CategoryTemplate extends BackendCategoryTemplate {
  /** The ID of the category template. */
  declare id: string
}
